module.exports = __webpack_public_path__ + "static/media/0.3deb0090.png";